const SHANTY_URL = "https://www.shantybb.com";
const SHANTY_LOGO =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_fa35d69f-5986-4533-b1b4-846f1468831d/artifacts/ffy9bmb7_SHANTY%20BB%20TRADEMARK%20APPLICATION.jpeg";

/**
 * The clickable Shanty BB partner badge, anchored to the bottom-left.
 * Both the emblem and the www.shantybb.com line link to the site.
 */
export const PartnerBadge = () => {
  return (
    <a
      href={SHANTY_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="shanty-bb-link"
      aria-label="Visit Shanty BB at www.shantybb.com"
      style={{ animationDelay: "2.05s" }}
      className="reveal group absolute bottom-6 left-6 z-50 flex flex-col items-center gap-2 md:bottom-8 md:left-8"
    >
      <span className="badge-float block">
        <span className="relative block rounded-full p-[2px] transition-transform duration-500 ease-out group-hover:scale-105">
          <span className="pointer-events-none absolute inset-0 rounded-full bg-[#c6a664]/40 opacity-0 blur-md transition-opacity duration-500 group-hover:opacity-100" />
          <img
            src={SHANTY_LOGO}
            alt="Shanty BB™ — Outdoors Reimagined™"
            data-testid="shanty-bb-logo"
            className="relative h-20 w-20 rounded-full border border-[#c6a664]/50 object-cover shadow-[0_10px_30px_rgba(0,0,0,0.55)] md:h-24 md:w-24"
          />
        </span>
      </span>
      <span
        data-testid="shanty-bb-url"
        className="font-body text-[10px] uppercase tracking-[0.28em] text-[#a3b1a9] transition-colors duration-300 group-hover:text-[#c6a664] md:text-xs"
      >
        www.shantybb.com
      </span>
    </a>
  );
};
